module.exports = __webpack_public_path__ + "static/img/live-bg-2.76b715bd.jpg";